// @flow
import styled from 'styled-components';
import colors from '../../assets/css/colors';

export const ButtonLoadMore = styled.button`
	width: 100%;
	font-weight: bold;
	background: #fff;
	box-shadow: ${colors.box_shadow};
	height: 50px;
	margin: .5em 0;
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	font-size: 12px;
	font-weight: bold;
    text-transform: uppercase;
	letter-spacing: 0.5px;
	line-height: 1;
	color: ${colors.title};
	outline: none;
	border: none;
	cursor: pointer;

	svg {
		margin-left: .25em;
	}
`;

export default ButtonLoadMore;


// WEBPACK FOOTER //
// ./src/components/ButtonLoadMore/index.js